import { createFileRoute, Navigate } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { CreditsPage } from '../../../../features/legacy-investor/credits-page'

// Credits live in the Wallet now; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/credits')({
  component: () => <AssistantSwitch assistant={<CreditsRedirect />} classic={<CreditsPage />} />,
})

function CreditsRedirect() {
  const { id } = Route.useParams()
  return <Navigate to="/app/investor/$id/wallet" params={{ id }} replace />
}
